const buttonColors = {
  primary: '#2C6EF2',
  onHover: '#C5D7FB',
  onHoverEndCall: '#FDC4C4',
  disable: '#FFFFFF',
  cancel: '#F05656',
};

export default buttonColors;
